import Parser from 'html-react-parser';
import { useSelector } from 'react-redux';
import l from '../../../../lang';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { canViewAndCopyApiKeys } from '../../../../store/payment-integration/roles';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';
import { ReactComponent as MagentoIcon } from '../../../../assets/icons/magento.svg';
import {
  segmentIntegrationsMagentoInstall,
  segmentIntegrationsMagentoKeysCopyApiKey,
  segmentIntegrationsMagentoKeysCopySecretKey,
  segmentIntegrationsMagentoPageLinkDocs,
} from '../../../../utils/analytics';
import IntegrationDetails from '../integration-details';
import ButtonLink from '../../../common/button-link';
import { getLanguage, openNewTabAndFocus } from '../../../../utils';
import InputSecret from '../../../common/input-secret';
import { Urls } from '../../../../config/urls';
import { Button } from '../../../common/button';

export default () => {
  const { apiKey, secretKey, setDetailsOpened } = usePaymentIntegration();
  const { auth } = useSelector(state => state);
  const canViewKeys = canViewAndCopyApiKeys(auth?.roles);

  const getDocumentationUrl = () => {
    const lang = getLanguage();
    switch (lang) {
      case 'es':
        return Urls.docs.magentoIntegration.es;
      case 'pt':
        return Urls.docs.magentoIntegration.pt;
      default:
        return Urls.docs.magentoIntegration.en;
    }
  };

  return (
    <IntegrationDetails icon={<MagentoIcon />} color="orange" onClose={() => setDetailsOpened(DetailsOpened.NONE)}>
      <div className="integration_details__title">{l('paymentIntegration.magento.details.headline')}</div>
      <p>
        <span>{Parser(l('paymentIntegration.magento.details.description'))} </span>
        <br />
        <br />
        <ButtonLink
          text={l('paymentIntegration.magento.details.link')}
          onClick={() => {
            segmentIntegrationsMagentoPageLinkDocs();
            openNewTabAndFocus(getDocumentationUrl());
          }}
        />
        <span>{Parser(l('paymentIntegration.magento.details.description2'))} </span>
      </p>
      <div className="integration__key">
        <div className="integration__key__title">{l('paymentIntegration.magento.details.key.headline')}</div>
        <div>{Parser(l('paymentIntegration.magento.details.key.description'))}</div>
        <InputSecret text={apiKey} label="API Key" onCopy={() => segmentIntegrationsMagentoKeysCopyApiKey()} disabled={!canViewKeys} />
        <InputSecret text={secretKey} label="Secret Key" onCopy={() => segmentIntegrationsMagentoKeysCopySecretKey()} disabled={!canViewKeys} />
      </div>
      <Button
        className="integration_details__button"
        onClick={() => {
          segmentIntegrationsMagentoInstall();
          openNewTabAndFocus(Urls.magentoAddDP);
        }}
      >
        {l('paymentIntegration.magento.details.button')}
      </Button>
    </IntegrationDetails>
  );
};
